import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appInputUpperCase]'
})
export class InputUpperCaseDirective {

  private el: ElementRef;

  constructor(el: ElementRef) {
    this.el = el;
  }

  // Listen for the input event to also handle copy and paste.
  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    this.el.nativeElement.value = this.el.nativeElement.value.toUpperCase();
  }
}
